import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import Translator from "Languages/Utility/Translator";
import { DialogContent, Slide } from "@material-ui/core";
import * as Icons from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { getGroupProfileWithTypeDesign } from "Stores/actions";
import { read, store } from "Helpers/LocalStorage";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { Grid } from "@material-ui/core";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import Input from "Components/Input/Input";
import NumberMask from "Components/Input/components/NumberMask";
import millimeterMask from "Components/Input/components/millimeterMask";
import DrawerService from "Services/http/endpoints/design/DrawerService";
import StatusHandler from "Helpers/StatusHandler";
import SelectPatternTbl from "./components/SelectPatternTbl";
import SelectShapes from "./components/SelectShapes/SelectShapes";
import ShapesList from "Constants/ShapesList";
import * as R from "ramda";
import NewUnitService from "Services/http/endpoints/design/NewUnitService";
import showNotify from "Helpers/Notify";
import {
  SAVE_DASTE_PROFILE_LIST_TYPE_DESIGN,
  SELECTED_UNIT_ID,
} from "Stores/actionTypes";
import { useTranslation } from "react-i18next";
import NewUnitFastMode from "./components/FastMode";
import { useSetState } from "Helpers/Hooks";
import NewUnitButtonManager from "./NewUnitButtonManager";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function NewUnit({
  disabled,
  backToSave,
  onEnterDialog,
  onExitDialog,
  onClick,
  setShow,
  designSetting,
  setDesignSetting,
}) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const {
    selectedProject,
    unitList,
    dasteProfileListWithTypeDesign,
    unitListPagination,
    selectedProfileType,
  } = useSelector((state) => ({
    selectedProject: state.project.selectedProject,
    selectedUnitId: state.design.selectedUnitId,
    unitList: state.design.unitList,
    dasteProfileListWithTypeDesign: state.design.dasteProfileListWithTypeDesign,
    unitListPagination: state.design.unitListPagination,
    selectedProfileType: state.design.selectedProfileType,
  }));
  const dispatch = useDispatch();

  const [unitListLoading, setUnitListLoading] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingOnSave, setLoadingOnSave] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [showButtonStatus, setShowButtonStatus] = useState(false);
  const [selectedPattern, setSelectedPattern] = useState(null);
  const [formValid, setFormValid] = useState({ name: false });
  const [selectPattern, setSelectPattern] = useState(0);
  const [selectedShape, setSelectedShape] = useState(ShapesList.rectangle[0]);
  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: "",
      validation: {
        required: true,
        maxLength: 15,
      },
      col: {
        sm: 4,
        xs: 12,
      },
    },
    location: {
      type: "text",
      value: "",
      col: {
        sm: 4,
        xs: 12,
      },
    },
    count: {
      type: "number",
      value: 1,
      validation: {
        required: true,
        isNumeric: true,
        min: 1,
      },
      col: {
        sm: 4,
        xs: 12,
      },
    },
    windGapWidth: {
      type: "millimeter",
      value: 0,
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
        min: 0,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    windGapHeight: {
      type: "millimeter",
      value: 0,
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
        min: 0,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
  });

  useEffect(() => {
    if (setShow) {
      setShowDialog(setShow);
      read("PatternDefault") ? setSelectPattern(2) : setSelectPattern(1);
    }
  }, [setShow]);

  const onShowDialog = () => {
    setShowDialog(true);
  };

  const onEnter = () => {
    onEnterDialog();
    if (read("isLockProject") && read("StypeU") === "2") {
      showNotify({
        text: t("lockedProject"),
        customClass: "error",
      });
      onClose();
    } else {
      onEnterActions();
    }
  };

  const onClose = (row, status = false) => {
    setShowDialog(false);
    onExitDialog(status);
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    if (name === "windGapHeight")
      setDesignSetting({ ...designSetting, BreakH: value });
    if (name === "windGapWidth")
      setDesignSetting({ ...designSetting, BreakW: value });
  };

  const onSelectPattern = (row) => {
    setSelectedPattern(row);
    setSelectPattern(2);
  };

  const onSelectShape = (shape) => {
    setSelectedShape(shape);
  };

  const setOpenDialog = (status) => {
    if (!disabled) {
      store("num", status);
      onClick();
    }
  };

  const saveNewUnit = async (newUnitData, designString) => {
    if (!read("PatternDefault")) {
      showNotify({ text: t("select_pattern"), customClass: "error" });
      return;
    }
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        setLoadingOnSave(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProject: selectedProject.Id,
          Type: read("PatternDefault").Type, //selectedPattern.Type
          IdTemplate: read("PatternDefault").Id, //selectedPattern.Id
          BreakFrameW: controls.windGapWidth.value,
          BreakFrameH: controls.windGapHeight.value,
          Name: controls.name.value,
          Location: controls.location.value,
          CountUnit: controls.count.value,
          Wunit: newUnitData.width,
          Hunit: newUnitData.height,
          Image: " ",
        };
        const response = await NewUnitService.postNewUnit(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          dispatch({
            type: SELECTED_UNIT_ID,
            selectedUnitId: response.data.Value,
            selectedUnitINfo: {
              Id: response.data.Value,
              CountUnit: data.CountUnit,
              HUnit: data.Hunit,
              Image: data.Image,
              Location: data.Location,
              Name: data.Name,
            },
          });
          store("unitId", response.data.Value);
          const URL = `/design/unit/${response.data.Value}?designString=${designString}`;
          onClear();
          onClose(null, true);
          backToSave(response.data.Value, designString, URL);

          setLoadingOnSave(false);
        } else {
          setLoadingOnSave(false);
        }
      } catch (err) {
        console.error("[catch error]", err);
      }
    } else {
      showNotify({
        text: t("invalidInformation"),
        customClass: "error",
      });
    }
  };

  const onClear = () => {
    dispatch({
      type: SAVE_DASTE_PROFILE_LIST_TYPE_DESIGN,
      dasteProfileListWithTypeDesign: [],
    });
  };

  const onEnterActions = async () => {
    if (selectedProject) {
      try {
        setControls({ name: { value: "" } });
        setFormValid({ name: false });
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProject: selectedProject.Id,
        };
        const count = await DrawerService.getProjectCountUnit(params);

        const genName = `${designSetting.NameUnit} ${count.data.Value + 1}`;
        setControls({ name: { value: genName } });
        setFormValid({ name: genName.length === 0 ? false : true });
        setControls({ count: { value: 1 } });
        setControls({ windGapHeight: { value: designSetting.BreakH } });
        setControls({ windGapWidth: { value: designSetting.BreakW } });

        // const response = await DrawerService.getSettingUnit(params);
        // let err = StatusHandler(response);
        // if (!err.isFail) {
        //     const data = response.data.Value;
        //     const genName = `${data.NameUnit} ${count.data.Value + 1}`
        //     setControls({ name: { value: genName } });
        //     setFormValid({ name: genName.length === 0 ? false : true });
        //     setControls({ count: { value: 1 } });
        //     setControls({ windGapHeight: { value: data.BreakH } });
        //     setControls({ windGapWidth: { value: data.BreakW } });
        // }
        setUnitListLoading(false);
      } catch (err) {}
    }
  };

  useEffect(() => {
    (async () => {
      if (dasteProfileListWithTypeDesign.length === 0) {
        try {
          setLoading(true);
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdType: selectedProfileType ? selectedProfileType : 1,
          };
          await dispatch(getGroupProfileWithTypeDesign(params));
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      }
    })();
  }, [dasteProfileListWithTypeDesign.length]);

  return (
    <>
      <NewUnitButtonManager
        loading={loading}
        onAction={(value) => setOpenDialog(value)}
      />
      {/* <div className="new-unit-button">
        <MuiButton
          color="secondary"
          title={<Translator id="addNewSquareUnit" />}
          innerIcon={<Icons.Square />}
          onClick={() => setOpenDialog(2)}
        />
        <MuiButton
          color="secondary"
          title={<Translator id="addNewUnit" />}
          innerIcon={<Icons.UiChecksGrid />}
          onClick={() => setOpenDialog(1)}
        />
      </div> */}
      {read("num") === 1 ? (
        <Dialog
          dir={direction}
          fullScreen
          fullWidth
          open={showDialog}
          TransitionProps={{
            onEnter: onEnter,
            onExit: onClose,
          }}
          TransitionComponent={Transition}
        >
          <div className="dialogHeader">
            <p>{t("addNewUnit")}</p>
          </div>
          <DialogContent
            id="new-unit-designer-mian"
            className={`p-0 ${
              direction === "rtl" ? "text-right" : "text-left"
            }`}
          >
            <BackDropLoading loading={loadingOnSave} />
            {!loading ? (
              <Grid container className="add-new-unit-main">
                <Grid container spacing={2} className="mb-2">
                  {Object.keys(controls).map((key, index) => {
                    return (
                      <Grid
                        item
                        md={2}
                        sm={controls[key].col.sm}
                        xs={controls[key].col.xs}
                        key={key + index}
                      >
                        <Input
                          setValue={setValue.bind(this)}
                          name={key}
                          validation={controls[key].validation}
                          label={<Translator id={key} />}
                          type={controls[key].type}
                          value={controls[key].value}
                          endIcon={
                            controls[key].type === "millimeter" ? (
                              <Translator id="millimeter" />
                            ) : (
                              ""
                            )
                          }
                          minLength={controls[key]?.validation?.minLength}
                          maxlength={controls[key]?.validation?.maxLength}
                          inputComponent={
                            controls[key].type === "millimeter"
                              ? millimeterMask
                              : controls[key].type === "number"
                              ? NumberMask
                              : ""
                          }
                        />
                      </Grid>
                    );
                  })}
                </Grid>
                {selectPattern === 2 ? (
                  <Grid item xs={12} className="info-alert-dialog primary">
                    <span>{`${t("selected_pattern")} :`}</span>
                    <p className="normalTitle">{read("PatternDefault").Name}</p>
                    <div className="info-alert-action">
                      <MuiIconButton
                        className="warning-fill"
                        icon={<Icons.X />}
                        title={t("list_olgo")}
                        onClick={() => setSelectPattern(1)}
                      />
                    </div>
                  </Grid>
                ) : (
                  <SelectPatternTbl onSelect={onSelectPattern} />
                )}
                <SelectShapes
                  onSelect={onSelectShape}
                  selectedShape={selectedShape}
                  windGapWidth={controls.windGapWidth.value}
                  windGapHeight={controls.windGapHeight.value}
                  saveNewUnit={saveNewUnit}
                  onClear={onClear}
                  onExit={onClose}
                />
              </Grid>
            ) : (
              <MuiSkeleton xs={3} number={12} />
            )}
          </DialogContent>
        </Dialog>
      ) : (
        <Dialog
          dir={direction}
          fullWidth
          maxWidth="sm"
          open={showDialog}
          TransitionProps={{
            onEnter: onEnter,
            // onExit: onClose
          }}
        >
          <NewUnitFastMode
            saveNewUnit={saveNewUnit}
            onExit={onClose}
            onSelectPattern={onSelectPattern}
            controls={controls}
            setValue={setValue}
            selected_Pattern={selectPattern}
          />
        </Dialog>
      )}
    </>
  );
}
